import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'
import '@/styles/index.css'
import App from '@/App.tsx'
import { AuthProvider } from '@/contexts/providers/auth-provider'
import { LanguageProvider } from '@/contexts/providers/language-provider'
import { initSentry } from '@/config/sentry'
import { SentryErrorBoundaryLazy } from '@/components/common/sentry'

// Initialize Sentry as early as possible
initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5分間はキャッシュを新鮮として扱う
      gcTime: 30 * 60 * 1000, // 30分間キャッシュを保持
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundaryLazy>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <LanguageProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </LanguageProvider>
        </BrowserRouter>
        {import.meta.env.VITE_APP_ENV === 'development' && <ReactQueryDevtools />}
      </QueryClientProvider>
    </SentryErrorBoundaryLazy>
  </StrictMode>
)
